import { useEffect, useState } from "react";
import axios from "axios";
import { Instagram } from "lucide-react";
import { Skeleton } from "../ui/skeleton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PROFILE = "https://www.instagram.com/nia.ecoversity/";
const OWN_PHOTOS = [
  { id: "community", image: "/photos/community-gathering.webp", caption: "A community group holding fresh greens in front of a mural" },
  { id: "drum", image: "/photos/healing-drum.webp", caption: "A hand drum resting among plants" },
  { id: "forest", image: "/photos/retreat-forest.webp", caption: "Building a stick shelter in a misty forest" },
  { id: "stones", image: "/photos/heart-stones.webp", caption: "Heart-shaped stones held by the water" },
];

const Tile = ({ post }) => (
  <a href={post.permalink || PROFILE} target="_blank" rel="noopener noreferrer" data-testid={`instagram-post-${post.id}`}
    className="group relative block aspect-square overflow-hidden bg-muted">
    <img src={post.image} alt={post.caption.slice(0, 120) || "Instagram post from Nia Ecoversity"} loading="lazy"
      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <span className="absolute inset-0 flex items-center justify-center bg-plum/0 transition-colors duration-300 group-hover:bg-plum/55">
      <Instagram className="h-8 w-8 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
    </span>
  </a>
);

export const InstagramStrip = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/instagram/feed`)
      .then(({ data }) => setPosts(data.posts.length ? data.posts : OWN_PHOTOS))
      .catch(() => setPosts(OWN_PHOTOS));
  }, []);

  return (
    <section id="instagram" className="border-t border-border py-24 lg:py-28" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">On Instagram</p>
            <h2 className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl">
              Life in the <span className="text-primary">village.</span>
            </h2>
          </div>
          <a href={PROFILE} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow-button"
            className="inline-flex items-center gap-3 self-start rounded-sm bg-plum px-6 py-3 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 md:self-auto">
            <Instagram className="h-4 w-4" /> Follow @nia.ecoversity
          </a>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-px border border-border bg-border md:grid-cols-4" data-testid="instagram-grid">
          {posts === null
            ? [0, 1, 2, 3].map((i) => <Skeleton key={i} className="aspect-square rounded-none" />)
            : posts.slice(0, 8).map((p) => <Tile key={p.id} post={p} />)}
        </div>
      </div>
    </section>
  );
};
